module.exports = __webpack_public_path__ + "static/img/guide-41.6e7151e6.png";